<template>
  <div class="ground-temp">
    <!-- 把banner通过插槽加入 -->
    <div class="banner-wrapper">
      <slot class="banner"></slot>
      <!-- <div class="joined-wrapper">
        <h1>参加总职位</h1>
        <div>
          <span>{{cnt[0]}}</span>
          <span>{{cnt[1]}}</span>
          <span>{{cnt[2]}}</span>
          <span>{{cnt[3]}}</span>
          <span>{{cnt[4]}}</span>
        </div>
      </div> -->
    </div>
    <h1>招聘职位</h1>
    <Joblist ref="joblist" :place="place" :selector="selector"/>
  </div>
</template>

<script>
import Joblist from './Joblist.vue'
export default {
  props: {
    place: String,
    selector: Array
  },
  data() {
    return {
      cnt: '01365'
    }
  },
  methods: {
    addZero(num, n) {
      let head = Math.pow(10, n) // 传 5 则 100000
      console.log(head)
      return ('' + (head + num)).slice(-5)
    }
  },
  created() {
    // console.log(this.addZero(1365, 5))
  },
  components: {
    Joblist
  }
}
</script>

<style lang="scss" scoped>
  .ground-temp {
    margin-top: 20px;
    .banner-wrapper {
      width: 718px;
      height: 360px;
      position: relative;
      > img {
        width: 100%;
        height: 100%;
      }
      .joined-wrapper {
        position: absolute;
        top: 76px;
        left: 0;
        right: 0;
        margin: auto;
        > h1 {
          font-size:56px;
          font-weight:bold;
          color:rgba(255,255,255,1);
          text-shadow:0px 4px 8px rgba(0,0,0,0.5);
          text-align: center;
        }
        > div {
          margin: 48px auto 0;
          width: 348px;
          display: flex;
          justify-content: space-between;
          > span {
            width:60px;
            height:90px;
            line-height: 90px;
            background:rgba(255,255,255,1);
            border-radius:12px;
            font-size:60px;
            color:#333333;
            text-align: center;
          }
        }
      }
    }
    > h1 {
      margin-top: 64px;
      margin-bottom: 16px;
      font-size:34px;
      font-weight:bold;
      color:#333333;;
      line-height: 1;
      &::before {
        content: '';
        display: inline-block;
        margin-right: 8px;
        width: 8px;
        height: 8px;
        background:#333333;
        vertical-align: top;
        position: relative;
        top: -2px;
        box-shadow: 0 12px 0 0 #333333, 0 24px 0 0 #333333;
        border-radius: 1px;
      }
    }
  }
</style>